<template>
  <div class="quiz-container">
    <div v-if="!showResult">
      <!-- Progress Bar -->
      <div class="progress-bar">
        <div class="progress" :style="{ width: progress + '%' }"></div>
        <div class="progress-text">{{ currentQuestionIndex + 1 }}/{{ questions.length }}</div>
      </div>

      <!-- Current Question -->
      <div class="question-card">
        <h2 class="question-text">{{ currentQuestion.text }}</h2>
        <div class="options-grid">
          <button
              v-for="(option, index) in currentQuestion.options"
              :key="index"
              @click="selectAnswer(option.letter)"
              :class="['option-btn', { 'selected': selectedAnswers[currentQuestionIndex] === option.letter }]"
          >
            {{ option.letter }}) {{ option.text }}
          </button>
        </div>
      </div>

      <!-- Navigation Controls -->
      <div class="navigation-btns">
        <button
            v-if="currentQuestionIndex > 0"
            @click="prevQuestion"
            class="nav-btn prev-btn"
        >
          Întrebarea anterioară
        </button>
        <button
            v-if="currentQuestionIndex < questions.length - 1"
            @click="nextQuestion"
            class="nav-btn next-btn"
            :disabled="!selectedAnswers[currentQuestionIndex]"
        >
          Următoarea întrebare
        </button>
      </div>
    </div>

    <!-- Results Screen -->
    <div v-else class="results-screen">
      <h2 class="result-title">Pictura care te reprezintă:</h2>
      <div class="result-card">
        <span v-if="result.image">
          <span v-if="result.url">
            <a :href="result.url">
              <img :src="result.image" :alt="result.title" class="result-image">
            </a>
          </span>
          <span v-else>
            <img :src="result.image" :alt="result.title" class="result-image">
          </span>

        </span>
        <h3 class="painting-title">{{ result.title }}</h3>
        <p class="painting-description">{{ result.description }}</p>
      </div>
      <button @click="resetQuiz" class="reset-btn">Încearcă din nou</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentQuestionIndex: 0,
      showResult: false,
      selectedAnswers: [],
      questions: [  // ACTUAL QUESTIONS NEED TO BE HERE
        {
          text: "Care este starea ta de spirit predominantă?",
          options: [
            {letter: "A", text: "Visătoare și melancolică"},
            {letter: "B", text: "Energică și plină de viață"},
            {letter: "C", text: "Calmă și echilibrată"},
            {letter: "D", text: "Misterioasă și introspectivă"}
          ]
        },
        {
          text: "Cum îți place să îți petreci timpul liber?",
          options: [
            {letter: "A", text: "Reflectând asupra vieții și scriind în jurnal"},
            {letter: "B", text: "Explorând locuri noi și cunoscând oameni interesanți"},
            {letter: "C", text: "Relaxându-te în natură sau meditând"},
            {letter: "D", text: "Citind cărți filozofice sau privind cerul nopții"}
          ]
        },
        {
          text: "Dacă ai putea călători în orice epocă artistică, unde ai merge?",
          options: [
            {letter: "A", text: "Secolul al XIX-lea, în plină perioadă romantică"},
            {letter: "B", text: "Perioada modernistă, plină de culoare și expresivitate"},
            {letter: "C", text: "Impresionismul, unde frumusețea naturii și lumina dominau"},
            {letter: "D", text: "Realismul, unde detaliile și simbolismul erau esențiale"}
          ]
        },
        {
          text: "Ce paletă de culori te atrage cel mai mult?",
          options: [
            {letter: "A", text: "Tonuri calde și luminoase, pastelate"},
            {letter: "B", text: "Culori puternice, contrastante și vibrante"},
            {letter: "C", text: "Nuanțe naturale, delicate și armonioase"},
            {letter: "D", text: "Jocuri de lumini și umbre, tonuri intense"}
          ]
        },
        {
          text: "Dacă ar trebui să îți descrii stilul personal într-un singur cuvânt, care ar fi acesta?",
          options: [
            {letter: "A", text: "Nostalgic"},
            {letter: "B", text: "Dinamic"},
            {letter: "C", text: "Elegant"},
            {letter: "D", text: "Profund"}
          ]
        }
      ],
      results: {
        A: {
          options: [
            {
              title: "„Fetița pădurarului” de Nicolae Tonitza",
              image: "https://mnar.ro/images/lucrari/Tonitza.jpg",
              url: null
            },
            {
              title: "„Toamna” de Ștefan Luchian",
              image: "https://s3-eu-west-1.amazonaws.com/a10ro/Lot/71415/conversions/erpsync-main-image-details.jpg",
              url: "https://www.artmark.ro/ro/licitatie/licitatia-de-iarna-4772022/lot/toamna-inocenta-ro-71415"
            }
          ],
          description: "Ești o persoană sensibilă și visătoare, care apreciază frumusețea subtilă a detaliilor. Îți place liniștea și ai un aer de nostalgie care atrage oamenii spre tine."
        },
        B: {
          options: [
            {
              title: "„Țărăncuță odihnindu-se” de Nicolae Grigorescu",
              image: "https://s3-eu-west-1.amazonaws.com/a10ro/Lot/98423-ro/conversions/erpsync-main-image-details.jpg",
              url: "https://www.artmark.ro/ro/licitatie/licitatia-de-iarna-inclusiv-o-selectie-din-colectia-compozitorului-anatol-vieru/lot/tarancuta-odihnindu-se-ro-98423"
            },
            {
              title: "„Fetița cu fundiță roz” de Nicolae Tonitza",
              image: "https://s3-eu-west-1.amazonaws.com/a10ro/Lot/76485/conversions/erpsync-main-image-details.jpg",
              url: "https://www.artmark.ro/ro/licitatie/licitatia-de-iarna-inclusiv-o-selectie-din-colectia-compozitorului-anatol-vieru/lot/tarancuta-odihnindu-se-ro-98423"
            }
          ],
          description: "Ești plină de energie, naturalețe și pasiune. Ai o personalitate intensă și iubești să te exprimi autentic, găsind frumusețea în viața simplă."
        },
        C: {
          options: [
            {
              title: "„Anemone” de Ștefan Luchian",
              image: "https://s3-eu-west-1.amazonaws.com/a10ro/Lot/20990/conversions/main-image-details.jpg",
              url: "https://www.artmark.ro/ro/licitatie/licitatia-de-toamna-top-100-mari-maestri-ai-artei-romanesti-178-2015/lot/anemone-ro-20990"
            },
            {
              title: "„Le coin musical” de Theodor Aman",
              image: "https://s3-eu-west-1.amazonaws.com/a10ro/Lot/93037-ro/conversions/erpsync-main-image-details.jpg",
              url: "https://www.artmark.ro/ro/licitatie/licitatia-de-vara-2024/lot/le-coin-musical-coltul-muzical-ro-93037"
            }
          ],
          description: "Ești o persoană echilibrată și rafinată, care apreciază armonia și sensibilitatea artistică. Ai o conexiune profundă cu natura și frumusețea fragilă a momentului."
        },
        D: {
          options: [
            {
              title: "„Pădurea de mesteceni” de Ion Andreescu",
              image: "https://upload.wikimedia.org/wikipedia/commons/5/54/Ion_Andreescu_-_Padure_de_mesteceni.jpg",
              url: null
            },
            {
              title: "„Strânsul fânului” de Nicolae Grigorescu",
              image: "https://s3-eu-west-1.amazonaws.com/a10ro/Lot/98528-ro/conversions/erpsync-main-image-details.jpg",
              url: "https://www.artmark.ro/ro/licitatie/licitatia-de-iarna-inclusiv-o-selectie-din-colectia-compozitorului-anatol-vieru/lot/stransul-fanului-ro-98528"
            }
          ],
          description: "Ești profundă, introspectivă și adesea pierdută în propriile gânduri. Ai o viziune puternică asupra vieții și apreciezi liniștea și frumusețea naturii în formele sale autentice."
        }
      }
    };
  },
  computed: {
    progress() {
      return ((this.currentQuestionIndex + 1) / this.questions.length) * 100;
    },
    currentQuestion() {
      return this.questions[this.currentQuestionIndex];
    },
    result() {
      const counts = {A: 0, B: 0, C: 0, D: 0};
      this.selectedAnswers.forEach(answer => {
        counts[answer] = (counts[answer] || 0) + 1;
      });

      const max = Math.max(...Object.values(counts));
      const resultKey = Object.keys(counts).find(key => counts[key] === max);
      const resultOptions = this.results[resultKey].options;
      const randomIndex = Math.floor(Math.random() * resultOptions.length);

      return {
        title: resultOptions[randomIndex].title,
        image: resultOptions[randomIndex].image,
        url: resultOptions[randomIndex].url,
        description: this.results[resultKey].description
      };
    }
  },
  methods: {
    selectAnswer(letter) {
      this.$set(this.selectedAnswers, this.currentQuestionIndex, letter);
      if (this.currentQuestionIndex === this.questions.length - 1) {
        this.showResult = true;
      }
    },
    nextQuestion() {
      if (this.currentQuestionIndex < this.questions.length - 1) {
        this.currentQuestionIndex++;
      }
    },
    prevQuestion() {
      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex--;
      }
    },
    resetQuiz() {
      this.currentQuestionIndex = 0;
      this.selectedAnswers = [];
      this.showResult = false;
    }
  }
};
</script>

<style scoped>
/* Add these new styles */
.result-image {
  max-width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: contain;
  margin-bottom: 1.5rem;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Existing styles below (unchanged) */
.quiz-container {
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.progress-bar {
  height: 8px;
  background: #eee;
  margin-bottom: 2rem;
  position: relative;
}

.progress {
  height: 100%;
  background: #343a40;
  transition: width 0.3s ease;
}

.progress-text {
  position: absolute;
  right: 0;
  top: -25px;
  color: #666;
  font-size: 0.9rem;
}

.question-card {
  background: #f8f9fa;
  padding: 2rem;
  margin-bottom: 1.5rem;
}

.question-text {
  font-size: 1.25rem;
  color: #2c3e50;
  margin-bottom: 1.5rem;
}

.options-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.option-btn {
  padding: 1rem;
  border: 2px solid #e9ecef;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.option-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.option-btn.selected {
  border-color: #343a40;
  background-color: #e3f2fd;
}

.navigation-btns {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}

.nav-btn {
  padding: 0.8rem 1.5rem;
  font-weight: 500;
}

.prev-btn {
  background: #343a40;
  color: #f8f9fa;
  border: 2px solid #343a40;
}

.next-btn {
  background: #343a40;
  color: white;
  margin-left: auto;
}

.next-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.results-screen {
  text-align: center;
}

.result-title {
  font-size: 1.5rem;
  color: #2c3e50;
  margin-bottom: 2rem;
}

.result-card {
  background: #f8f9fa;
  padding: 2rem;
  margin: 2rem 0;
}

.painting-title {
  color: #343a40;
  margin-bottom: 1rem;
}

.painting-description {
  color: #666;
  line-height: 1.6;
}

.reset-btn {
  background: #343a40;
  color: white;
  padding: 1rem 2rem;
  font-weight: bold;
}
</style>